import { useMemo } from 'react';

export const mobile = () => {
  const handleResize = (setIsMobile: (mobile: boolean) => void) => {
    if (window.innerWidth < 600) {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
  };

  return useMemo(
    () => ({
      handleResize,
    }),
    []
  );
};
